import { ChangeDetectionStrategy, EventEmitter, Input, Output, ViewChild, Component, OnInit, OnDestroy, HostListener, ChangeDetectorRef } from '@angular/core';
import { FormControl, UntypedFormControl, Validators } from '@angular/forms';
import { IAutocompleteDataRow } from '../interfaces/autocomplete-data-row.interface';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutocompleteComponent implements OnInit, OnDestroy {

  @ViewChild('autocomplete') autocomplete;

  @Input() data: IAutocompleteDataRow[];
  @Input() searchKeyword: string;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() historyIdentifier: string;
  @Input() initialValue: any;
  @Input() control: UntypedFormControl;
  @Input() historyHeader: string = 'Showing only recently used';
  @Input() upperCase: boolean;

  @Output() itemAdded: EventEmitter<string> = new EventEmitter();
  @Output() selected: EventEmitter<any> = new EventEmitter();

  search: string = '';

  isPanelOpen: boolean;

  showAllNode: Element;

  constructor(private cdr: ChangeDetectorRef) {}

  selectEvent(item) {
    this.selected.emit(item);
  }

   //don't remove this listener as it triggers required change detection
  @HostListener('keydown', ['$event'])


  ngOnInit(): void {
    if (this.control.hasValidator(Validators.required)) {
     this.control.setValidators([Validators.required, this.hasSelectedIdValidator]);
     this.control.updateValueAndValidity();
    }
   }

  onChangeSearch(search: string) {
    let empty = /^\s*$/;
    if(typeof(search) === 'string' && !empty.test(search)) {
      this.search = search.trim();
    }
  }

  focus() {
    this.autocomplete.focus();
  }

  onCleared(): void {
    setTimeout(() => {
      this.focus();
    });
  }

  onFocused(e): void {
    this.isPanelOpen = true;
    setTimeout(() => {
      this.showAllNode = document
        .querySelector('.ng-autocomplete')?.querySelector('.heading')?.querySelector('.x');
      if (this.showAllNode) {
        this.showAllNode.addEventListener('click', this.showAll.bind(this));
      }
    });
  }

  addItem() {
    this.itemAdded.emit(this.search);
  }

  closePanel(): void {
    this.autocomplete.close();
  }

  isInvalid() {
    return this.control.touched && !this.control.valid;
  }

  showAll(): void {
    setTimeout(() => {
      this.autocomplete?.focus();
    });
  }

  hasSelectedIdValidator(control: FormControl): {[s:string]: boolean} | null { 
    if(!control?.value?.id) {
      return {"idRequired": true};
    }
    return null;
  }

  markForCheck(): void {
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.showAllNode?.removeEventListener('click', this.showAll.bind(this))
  }
}
